import { connect } from "react-redux";
import * as userActions from "../redux/actions/userActions";
import { useHistory, Redirect } from "react-router-dom";
 
function Login(props:any) {
  const history = useHistory();
  if (props.isLogged === true) {
    return <Redirect to="/" />;
  }

  function loginUser() {

    const s = document.getElementById("selectOption") as any;
    if (s.value.length === 0)
      return;
    const [user] = props.users.filter((u:any) => u.id === s.value);
    if (Object.keys(user).length > 0) {
      props.userLogin(user);
      props.getAllUsers();
      history.push("/");
    }
  }

  return (
    <>
      <div className="row justify-content-center col-12">
        <div className="setBorder center col-5">
          Welcome to the Would You Rather App!
        </div>
        <div className="center col-7">Please sign in to continue</div>
        <br />
        <div className="center col-12">
          <select
            id="selectOption"
            className="col-4 form-select"
            aria-label="Default select example"
            defaultValue=""
          >
            <option value="">Select User</option>

            {props.users.map((user:any) => (
              <option key={user.id} value={user.id}>
                {user.name}
              </option>
            ))}
          </select>
          <br />
          <br />
          <button onClick={() => loginUser()} className="btn btn-success col-4">
            Sign in
          </button>
        </div>
      </div>
    </>
  );
}

const mapStateToProps = (state:any) => {
  return {
    users: state.userReducer.users,
    isLogged: state.userReducer.loggedUser.id ? true : false,
  };
};

const mapDispatchToProps = (dispatch:any) => {
  return {
    getAllUsers: () => dispatch(userActions.getAllUsers()),
    userLogin: (user:any) => dispatch(userActions.userLogin(user)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);
